import classNames from "classnames"
import { useTableMapState } from "./TableMapState";
import Dropdown from "@/migrated-widgets/table-map/components/molecules/Dropdown";
import { ChevronDownIcon } from "@/components/icons/ChevronDownIcon";
import { DropdownItem } from "@/migrated-widgets/table-map/components/molecules/Dropdown/Item";
import { locationProducts } from "./constants";

export const FilterByCampaign: React.FC<{}> = () => {
  const { distinctCampaigns, setCampaigns, campaigns, campaignColors, currentProduct } = useTableMapState();

  const allCampaigns = distinctCampaigns.map((campaignName, index) => campaignName);

  const product = locationProducts.find((locationProduct) => locationProduct.id === currentProduct)

  const toggleCampaign = (campaignName: string) => {
    setCampaigns((prev) => {
      return prev.includes(campaignName) ? campaigns.filter(el => el !== campaignName) : [...prev, campaignName];
    })
  }

  const toggleSelectAllClearAllCampaigns = () => {
    setCampaigns((prev) => {
      return prev.length > 0 ? [] : allCampaigns;
    })
  }

  const isActiveCampaign = (campaignName: string) => {
    if (!campaigns.length) return true;

    return !campaigns.includes(campaignName);
  }

  return (
    <div className="min-w-40 w-max">
      <Dropdown
        closeOnClick={true}
        dropdownList={{ className: 'text-sm border border-gray-200 rounded-lg shadow-md', width: 'w-full' }}
        trigger={
          <button className="w-full border font-medium border-gray-200 text-gray-700 px-3 py-1.5 rounded-lg text-sm flex gap-2 justify-between items-center hover:bg-gray-50">
            <div className="flex items-center gap-1.5">
              <span className="text-gray-500 text-nowrap">{product?.name ?? ''} Campaign Targeting:</span>
              <span>{campaigns.length > 0 ? `${campaigns.length} selected` : 'All'}</span>
            </div>
            <ChevronDownIcon className="w-3.5" />
          </button>
          }
        listFooter={
        <DropdownItem
          key={`dropdown-select-all-clear-all`}
          onClick={() => toggleSelectAllClearAllCampaigns()}
          padding="p-2 pl-6"
        >
          <div className={classNames('flex', 'gap-2', 'text-[#448793]', 'items-center')}>
            <span>Select All - Clear All</span>
          </div>
        </DropdownItem>
      }>

        {
          distinctCampaigns.map((campaignName, index) =>
            <DropdownItem
              key={`${campaignName}-${index}`}
              onClick={() => toggleCampaign(campaignName)}
            >
              <div className={classNames('flex', 'gap-2', 'items-center')}>
                <div style={isActiveCampaign(campaignName) ? { backgroundColor: campaignColors[campaignName] } : {}} className={classNames('w-2',
                  'h-2',
                  'rounded-sm',
                  'bg-gray-100',
                  'border',
                  'border-gray-300',
                  { 'border-0': isActiveCampaign(campaignName) }
                )}></div>
                <span>{campaignName}</span>
              </div>
            </DropdownItem>
          )
        }

      </Dropdown>
    </div>
  )
}